<template>
    <div class="tw-relative">
        <div
            ref="body"
            class="dk-wizard-lead-form-modal__scroll-wrapper lg:tw-h-[502px] lg:tw-overflow-y-auto [&::-webkit-scrollbar]:max-lg:tw-hidden [&::-webkit-scrollbar]:lg:tw-bg-border-color [&::-webkit-scrollbar]:lg:tw-rounded-[10px] [&::-webkit-scrollbar]:lg:tw-w-2 [&::-webkit-scrollbar-thumb]:lg:tw-w-1 [&::-webkit-scrollbar-thumb]:lg:tw-bg-negative-subtle [&::-webkit-scrollbar-thumb]:hover:lg:tw-bg-slate-400 [&::-webkit-scrollbar-thumb]:active:lg:tw-bg-slate-600 [&::-webkit-scrollbar-thumb]:lg:tw-rounded-[10px] [&::-webkit-scrollbar-thumb]:lg:tw-border-2 [&::-webkit-scrollbar-thumb]:lg:tw-border-solid [&::-webkit-scrollbar-thumb]:lg:tw-border-transparent [&::-webkit-scrollbar-thumb]:lg:tw-bg-clip-content"
            :style="{ height: `${customHeight}px` }"
            @scroll.passive="hasScroll && !isMobile && debouncedHandleScroll()"
        >
            <slot></slot>
        </div>
        <div
            v-if="showGradient"
            class="dk-wizard-lead-form-modal__scroll-gradient max-lg:tw-hidden tw-absolute tw-bottom-0 tw-right-0 lg:tw-h-14 tw-w-full tw-mr-4 tw-pointer-events-none tw-bg-gradient-to-t tw-from-white"
        ></div>
    </div>
</template>

<script>
import { EventBus } from '@v4/common/utils/event-bus';
import { debounce } from 'lodash';

export default {
    name: 'DkWizardLeadFormScrollWrapper',
    props: {
        isMobile: {
            type: Boolean,
            default: false,
        },
        tabId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            customHeight: null,
            hasScroll: false,
            showGradient: false,
            debouncedHandleScroll: null,
        };
    },
    mounted() {
        this.debouncedHandleScroll = debounce(this.handleScroll, 100);

        EventBus.$on('DkColorPicker:show-less-toggle', this.toggleScroll);

        if (!this.isMobile) {
            this.handleModalSizeOnDesktop();
        }
    },
    beforeDestroy() {
        EventBus.$off('DkColorPicker:show-less-toggle', this.toggleScroll);
    },
    methods: {
        handleModalSizeOnDesktop() {
            // if the screen height is less than the modal max height
            const modalMaxSize = 800;
            const defaultScrollSize = 502;
            if (window.innerHeight < modalMaxSize) {
                this.customHeight = defaultScrollSize - (modalMaxSize - window.innerHeight);
            }

            // if the screen height is bigger than the modal max height
            this.checkIfScrollableContent();
        },
        handleScroll() {
            let defaultScrollTop = 0;

            if (this.$refs.body.scrollTop < defaultScrollTop) {
                return;
            }

            defaultScrollTop = this.$refs.body.scrollTop <= 0 ? 0 : this.$refs.body.scrollTop;

            // On smaller screens (e.g. MacBook Air), this math doesn't work at 100%,
            // that's why there is a need for an additional 1 pixel.
            if (
                this.$refs.body.scrollTop + 1 + this.$refs.body.offsetHeight >= this.$refs.body.scrollHeight &&
                this.showGradient
            ) {
                this.toggleGradient(false);
            } else if (!this.showGradient) {
                this.toggleGradient(true);
            }
        },
        toggleGradient(showGradient) {
            this.showGradient = showGradient;
        },
        toggleScroll(hasScroll) {
            const isScrollActive = this.customHeight > 0 || hasScroll;
            this.updateScrollStatus(isScrollActive);
            if (this.hasScroll !== this.showGradient) {
                this.toggleGradient(this.hasScroll);
            }
        },
        updateScrollStatus(hasScroll) {
            if (this.tabId === 'wizard_form__offers' && !hasScroll) {
                return;
            }

            if (this.hasScroll !== hasScroll) {
                this.hasScroll = hasScroll;
                this.$emit('has-scroll-changed', { hasScroll, tabId: this.tabId });
            }
        },
        checkIfScrollableContent() {
            const interval = setInterval(() => {
                const isBodyRendered =
                    this.$refs.body && this.$refs.body.offsetHeight > 0 && this.$refs.body.scrollHeight > 0;
                if (isBodyRendered) {
                    if (this.$refs.body.offsetHeight < this.$refs.body.scrollHeight) {
                        this.updateScrollStatus(true);
                        this.showGradient = true;
                    }
                    clearInterval(interval);
                }
            }, 50);
        },
    },
};
</script>
